import React from 'react';

import { AccountContext } from '../../Context/AccountContext';
import { LocalCartContext } from '../../Context/LocalCartContext';
import { ShopwareCartContext } from '../../Context/ShopwareCartContext';
import { CartContextInterface, LocalCart, ShopwareCart } from '../Types';

enum Status {
    FILLED,
    EMPTY,
}

export default function CartHeaderIcon() {
    const { isLoggedIn } = React.useContext(AccountContext);
    let cart: ShopwareCart | LocalCart;
    let setCartVisibility: (visibility: boolean) => void;
    let totalItemsInCarts: number;

    const context: React.Context<CartContextInterface> = isLoggedIn ? ShopwareCartContext : LocalCartContext;
    ({ cart, setCartVisibility, totalItemsInCarts } = React.useContext(context));

    const [status, setStatus] = React.useState<Status>(Status.EMPTY);

    React.useEffect(() => {
        if (totalItemsInCarts > 0) {
            setStatus(Status.FILLED);
        } else {
            setStatus(Status.EMPTY);
        }
    }, [cart]);

    const icon = () => {
        if (status === Status.FILLED) {
            return (
                <svg className="icon">
                    <use xlinkHref="#icon-shopping-cart-full" />
                </svg>
            );
        }

        return (
            <svg className="icon">
                <use xlinkHref="#icon-shopping-cart-empty" />
            </svg>
        );
    };

    const bubble = () => {
        if (totalItemsInCarts === 0) {
            return null;
        }

        return <span className="header-cart__badge">{totalItemsInCarts}</span>;
    };

    const toggleCart = () => {
        setCartVisibility(!cart.visible);
    };

    return (
        <button type="button" className="header-cart__button" onClick={toggleCart}>
            {icon()}
            {bubble()}
        </button>
    );
}
